var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ApexChart',{attrs:{"type":"rangeBar","chartHeight":_vm.chartHeight,"chartData":_vm.chartData}})
}
var staticRenderFns = []

export { render, staticRenderFns }